import {
  AppAvatar,
  AppGridBox,
  AppLink,
  AppSkeletonBasicInfo,
  AppText,
  AppTitle,
  ColorInfoCard,
  InfoCard,
} from "../../../commons/components";
import AppBox from "../../../commons/components/Box";
import IconApproval from "../../../commons/components/icons/approval";
import IconProhibited from "../../../commons/components/icons/prohibited";
import { TeamStatusEnum } from "../../../commons/enums/team-status-enum";
import { formatDate } from "../../../commons/utilities/date-utils";
import { useAppSelector } from "../../../hooks/app";
import { StatusEnum } from "../../../commons/enums/status-enum";
import SubTeamCoach from "./components/subTeamCoach/SubTeamCoaches";

export default function SubTeamManageProfile() {
  const { subTeamInfo, subTeamInfoStatus } = useAppSelector((state) => state.footballManageSubTeam);

  return (
    <AppBox className="page-content" gap="md">
      <>
        {subTeamInfoStatus === StatusEnum.Loading ? (
          <AppSkeletonBasicInfo />
        ) : (
          <AppBox mb="sm" gap="sm" flexDirection="column">
            <AppBox flexDirection="column" gap="sm">
              <AppTitle as="h5">Basic Information</AppTitle>
              <AppBox flexDirection="column" gap="sm">
                <AppGridBox columns={3} gap="sm">
                  <InfoCard
                    label="Parent Team Name"
                    title={subTeamInfo.parent.name}
                    alignItems="start"
                    shadow="xs"
                    cardLink={`/manage/teams/${subTeamInfo.parent.id}`}
                    rightSide={<AppAvatar username={subTeamInfo.parent.name} src={subTeamInfo.parent.logo!} />}
                  />
                  <InfoCard
                    label="Sub-team's Short Name"
                    title={subTeamInfo.shortName}
                    alignItems="start"
                    shadow="xs"
                  />
                  <InfoCard
                    label="Sub-team's Abbreviated Name"
                    title={subTeamInfo.abbreviation}
                    alignItems="start"
                    shadow="xs"
                  />
                  <InfoCard
                    label="Foundation Date"
                    title={formatDate(subTeamInfo.founded, "D MMM, YYYY") || "-"}
                    alignItems="start"
                    shadow="xs"
                  />
                  <InfoCard
                    label="Sub-team's Status"
                    title={subTeamInfo.status === Number(TeamStatusEnum.Active) ? "Active" : "Terminated"}
                    icon={
                      subTeamInfo.status === Number(TeamStatusEnum.Active) ? (
                        <IconApproval height={32} width={32} color="var(--fg-outline-success)" />
                      ) : (
                        <IconProhibited height={32} width={32} color="var(--fg-outline-danger)" />
                      )
                    }
                    alignItems="start"
                    shadow="xs"
                  />
                  {subTeamInfo.homeColor && (
                    <ColorInfoCard
                      color={subTeamInfo.homeColor}
                      title="Home"
                      label="Sub-team's Color"
                      alignItems="start"
                      shadow="xs"
                    />
                  )}
                  {subTeamInfo.awayColor && (
                    <ColorInfoCard
                      color={subTeamInfo.awayColor}
                      title="Away"
                      label="Sub-team's Color"
                      alignItems="start"
                      shadow="xs"
                    />
                  )}
                  {subTeamInfo.thirdColor && (
                    <ColorInfoCard
                      color={subTeamInfo.thirdColor}
                      title="Optional"
                      label="Sub-team's Color"
                      alignItems="start"
                      shadow="xs"
                    />
                  )}
                  {subTeamInfo.goalkeeperHomeColor && (
                    <ColorInfoCard
                      color={subTeamInfo.goalkeeperHomeColor}
                      title="Home"
                      label="Goalkeeper's Color"
                      alignItems="start"
                      shadow="xs"
                    />
                  )}
                  {subTeamInfo.goalkeeperAwayColor && (
                    <ColorInfoCard
                      color={subTeamInfo.goalkeeperAwayColor}
                      title="Away"
                      label="Goalkeeper's Color"
                      alignItems="start"
                      shadow="xs"
                    />
                  )}
                </AppGridBox>
              </AppBox>
            </AppBox>
            <AppBox flexDirection="column" gap="xs">
              <AppTitle as="h5">Description</AppTitle>
              <AppText as="p" fontWeight="medium" size="lg">
                <span
                  dangerouslySetInnerHTML={{
                    __html: subTeamInfo.description || "There is not any description.",
                  }}
                ></span>
              </AppText>
            </AppBox>
          </AppBox>
        )}
      </>
      <SubTeamCoach />
    </AppBox>
  );
}
